export default "__VITE_ASSET__Rjc5Gu8___"